import { Categories } from "@/components/Navigation/FlyoutMenu/components/category/categories";
import { Category as CategoryBase } from "@/components/Navigation/FlyoutMenu/components/category/category";
import { useLinkContext } from "@/components/Navigation/FlyoutMenu/components/category/components/context/link.context";
import { Link } from "@/components/Navigation/FlyoutMenu/components/category/components/link";
import { Links } from "@/components/Navigation/FlyoutMenu/components/category/components/links";
import { Title } from "@/components/Navigation/FlyoutMenu/components/category/components/title";
import { useCategoryContext } from "@/components/Navigation/FlyoutMenu/components/category/context/category.context";
import { Content } from "@/components/Navigation/FlyoutMenu/components/content/content";
import { useFlyoutMenuContext } from "@/components/Navigation/FlyoutMenu/context/flyoutMenu.context";
import { Base } from "@/components/Navigation/FlyoutMenu/flyoutMenu.base";

export const FlyoutMenu = Object.assign(Base, {
    useContext: useFlyoutMenuContext,
    Content: Content,
    Categories: Categories,
    Category: Object.assign(CategoryBase, {
        useContext: useCategoryContext,
        Title: Title,
        Links: Links,
        Link: Object.assign(Link, {
            useContext: useLinkContext
        })
    })
});
